module.exports = __webpack_public_path__ + "static/media/盈浦复兴.be6e4ff7.jpg";